import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { z } from "zod";
import useAuth from "@hooks/useAuth";
import { getDomainById, updateDomain } from "@redux/slices/domains";
import { useNavigate } from "react-router";
import LoadingScreen from "@components/LoadingScreen";
import { ChevronLeft } from "lucide-react";

// Define Zod schema
const emailAccountSchema = z.object({
  domain_name: z
    .string()
    .min(1, "Domain name is required")
    .regex(
      /^(?!www\.|https?:\/\/)/,
      "Invalid domain. Must not start with www, http://, or https://"
    ),
});

type DomainFormValues = z.infer<typeof emailAccountSchema>;

const EditDomain: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const { user } = useAuth();
  const navigate = useNavigate();

  // Initialize form with react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<DomainFormValues>({
    resolver: zodResolver(emailAccountSchema),
  });

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const getData = async () => {
    const data = await getDomainById(
      Number(window.location.pathname.split("/")[2])
    );
    setValue("domain_name", data?.domain_name);
    setLoading(false);
  };

  const onSubmit = async (data: DomainFormValues) => {
    setLoading(true);
    await updateDomain(
      window.location.pathname.split("/")[2],
      data,
      "Updated Successfully"
    );
    setLoading(false);
    navigate(`/blacklist/${user.id}`);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="bg-white p-8">
          <h4 className="text-xl font-bold flex items-center -ms-2 mb-5">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Edit Domain
          </h4>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <p className="text-[#71717A] text-sm mb-1">Domain Name</p>
              <Input
                {...register("domain_name")}
                placeholder="Please only type in the domain name and domain ending (e.g: aquisize.de)"
              />
              {errors.domain_name && (
                <span className="text-red-600 text-sm mt-1">
                  {errors.domain_name.message}
                </span>
              )}
            </div>
            <Button className="mt-6" type="submit">
              Update
            </Button>
          </form>
        </div>
      )}
    </div>
  );
};

export default EditDomain;
